module.exports = "/images/london-2.jpg";